// DONT EDIT THIS FILE. AUTOGENERATED. 
export enum SideBarTKeys {
	bronzeMembership = 'SideBar.bronzeMembership',
	chatSupport = 'SideBar.chatSupport',
	developer = 'SideBar.developer',
	emissions = 'SideBar.emissions',
	extensions = 'SideBar.extensions',
	financials = 'SideBar.financials',
	fleetManager = 'SideBar.fleetManager',
	fuelManagement = 'SideBar.fuelManagement',
	getQuote = 'SideBar.getQuote',
	goBack = 'SideBar.goBack',
	helpAndSupport = 'SideBar.helpAndSupport',
	installedExtensions = 'SideBar.installedExtensions',
	login = 'SideBar.login',
	logistics = 'SideBar.logistics',
	maintenance = 'SideBar.maintenance',
	marketplace = 'SideBar.marketplace',
	myMachines = 'SideBar.myMachines',
	myOrders = 'SideBar.myOrders',
	myRequests = 'SideBar.myRequests',
	notAllowed = 'SideBar.notAllowed',
	notAllowedDesc = 'SideBar.notAllowedDesc',
	notifications = 'SideBar.notifications',
	productivity = 'SideBar.productivity',
	settings = 'SideBar.settings',
	signup = 'SideBar.signup',
	tableau = 'SideBar.tableau',
	tendering = 'SideBar.tendering',
	trackProjects = 'SideBar.trackProjects',
	unverifiedAccount = 'SideBar.unverifiedAccount',
	utilization = 'SideBar.utilization',
	verifiedAccount = 'SideBar.verifiedAccount',
}

